let config = {
    phonePattern: '^[0-9+()\.\-\\s]+$',
    emailPattern: '^\\S+@\\S+\\.\\S+$',
    invalid: 'invalid',
    error: 'form__error',
    suggestion: '.form__suggestion',
    errorRequired: '.form__error--required',
    errorWordCount: '.form__error--wordcount',
    errorMinSybols: '.form__error--minsymbols',
    errorPassword: '.form__error--password',
    errorConfirmPassword: '.form__error--confirm-password',
    errorEmail: '.form__error--email',
    errorName: '.form__error--name',
    errorPhone: '.form__error--phone',
    lateValidation: 'js-validate-late',
    formErrorMessage: '[data-form-global-error]',
    hiddenCls: 'hidden'
};

export default class Validator {
    constructor(element, options) {
        config = $.extend(config, options);

        this.$element = $(element);
        this.$form = this.$element.parents('form');
    }

    validateForm(event) {
        this.$form.find('input, select, textarea').each((index, field) => {
            let validator = $(field).data('validator');
            if (validator !== undefined && typeof(validator['validateField']) === 'function') {
                $.proxy(validator, 'validateField')();
            }
        });

        if (this.$form.find('.' + config.invalid).length > 0) {
            event.preventDefault();
            this.$form.find(config.formErrorMessage).removeClass(config.hiddenCls);
            return false;
        }
    }

    validateConfirmPassword() {
        return this.$form.find('[data-validation-rule="password"]').val() === this.$form.find('[data-validation-rule="confirm-password"]').val();
    }

    validateField() {
        if (this.$element.attr('required') !== undefined && this.$element.val() === '') {
            this.showError(config.invalid, config.errorRequired);
            return;
        }

        if (this.$element.data('validationRule') === 'password' && this.validatePassword(this.$element.val()) === false) {
            this.showError(config.invalid, config.errorPassword);
            return;
        }

        if (this.$element.data('validationRule') === 'confirm-password' && this.validateConfirmPassword(this.$element.val()) === false) {
            this.showError(config.invalid, config.errorConfirmPassword);
            return;
        }

        if (this.$element.data('validationRule') === 'name' && this.validateName(this.$element.val()) === false) {
            this.showError(config.invalid, config.errorName);
            return;
        }

        if (this.$element.attr('type') === 'email' && this.validateEmail(this.$element.val()) === false) {
            this.showError(config.invalid, config.errorEmail);
            return;
        }

        if (this.$element.attr('type') === 'tel' && this.validatePhone(this.$element.val()) === false) {
            this.showError(config.invalid, config.errorPhone);
            return;
        }

        if (this.$element.data('minWords') && this.validateMinWords(this.$element.val(), this.$element.data('minWords')) === false) {
            this.showError(config.invalid, config.errorWordCount);
            return;
        }

        if (this.$element.data('minSymbols') && this.validateMinSymbols(this.$element.val(), this.$element.data('minSymbols')) === false) {
            this.showError(config.invalid, config.errorMinSybols);
            return;
        }

        if (this.$element.attr('minlength') && this.validateMinLength(this.$element.val(), this.$element.attr('minlength')) === false) {
            this.showError(config.invalid, config.errorWordCount);
            return;
        }

        let dependsSelector = this.$element.data('validator-depends');

        if (dependsSelector !== undefined && this.validateDependentField(dependsSelector) === false) {
            let trigger = this.$element.data('validator-depends-trigger-invalid');

            if (trigger !== undefined && trigger.length > 0) {
                this.$element.trigger(trigger);
            }
            return;
        }
    }

    validatePassword(val) {
        const isCorrectLength = function (pw) {
            return (typeof pw === 'string' && pw.length > 5);
        };
        const hasNumber = function (pw) {
            return (typeof pw === 'string' && /\d/.test(pw));
        };
        const hasLowerCase = function (pw) {
            return (typeof pw === 'string' && /[a-z]/.test(pw));
        };
        const hasUpperCase = function (pw) {
            return (typeof pw === 'string' && /[A-Z]/.test(pw));
        };

        if (isCorrectLength(val) && hasUpperCase(val) && hasLowerCase(val) && hasNumber(val)) {
            return true;
        }

        this.showError(config.invalid, config.errorPassword);
        return false;
    };

    validateName(val) {
        return !/[^a-zA-Z\sàéèìòù]/.test(val);
    }

    validateDependentField(dependsSelector) {
        let $dependsField = $(dependsSelector);

        if (this.$element.val() === undefined || this.$element.val().length === 0) {
            $.proxy(this, 'resetField')();
            return true;
        }

        if ($dependsField.val() === undefined || $dependsField.val().length === 0) {
            this.$element.addClass(config.invalid);
            return false;
        }

        $.proxy(this, 'resetField')();
        return true;
    }

    validateMinSymbols(value, minSymbols) {
        let val = value.trim().length;

        return val >= minSymbols;
    }

    validateFieldMaxLength() {
        if (this.$element.attr('maxlength') && this.$element.val().length > 0) {
            if (this.validateMaxLength(this.$element.val(), this.$element.attr('maxlength')) === false) {
                this.showError(config.invalid, config.errorWordCount);
            } else {
                $.proxy(this, 'resetField')();
            }

            return;
        }
    }

    validateFieldMinLength() {
        if (this.$element.attr('minlength') && this.$element.val().length > 0) {
            if (this.validateMinLength(this.$element.val(), this.$element.attr('minlength')) === false) {
                this.showError(config.invalid, config.errorWordCount);
            } else {
                $.proxy(this, 'resetField')();
            }
            return;
        }
    }

    validateMinWords(value, minWords) {
        let val = value.trim().replace(/\W+/gi, ' ');
        let count = val === '' ? 0 : value.split(' ').length;

        return count >= minWords;
    }

    validateMaxLength(value, maxLength) {
        return value.length < maxLength;
    }

    validateMinLength(value, minLength) {
        let val = value.trim();
        return val.length >= minLength;
    }

    validatePhone(value) {
        let result = false;

        if (value === '') {
            return true;
        }

        if (new RegExp(config.phonePattern).test(value)) {
            result = value;
        }

        return result;
    }

    parsePhone() {
        let regex = new RegExp(config.phonePattern);
        let value = this.$element.val();
        let finalValue = '';

        for (let i = 0; i < value.length; i++) {
            if (regex.test(value[i])) {
                finalValue += value[i];
            }
        }

        this.$element.val(finalValue);
    }

    validateEmail(value) {
        let result = false;

        if (new RegExp(config.emailPattern).test(value)) {
            result = value;
        }

        return result;
    }

    showError(errorClassName, elementClassName) {
        this.$element.addClass(errorClassName);
        this.$element.siblings(elementClassName).show();
        this.$element.siblings(config.suggestion).hide();
    }

    resetField() {
        this.$element.removeClass(config.invalid);
        this.$element.siblings('.' + config.error).hide();
        this.$element.siblings(config.suggestion).show();
    }

    init() {
        this.$element
            .off('focus.validator', '', $.proxy(this, 'resetField'))
            .on('focus.validator', $.proxy(this, 'resetField'))
            .data('validator', this);

        if (!this.$element.hasClass(config.lateValidation)) {
            this.$element
                .off('blur.validator', '', $.proxy(this, 'validateField'))
                .on('blur.validator', $.proxy(this, 'validateField'));
        } else {
            this.$element
                .off('blur.validator', '', $.proxy(this, 'resetField'))
                .on('blur.validator', $.proxy(this, 'resetField'));
        }

        if (this.$element.attr('maxlength')) {
            this.$element
                .off('input.validator', '', $.proxy(this, 'validateFieldMaxLength'))
                .on('input.validator', $.proxy(this, 'validateFieldMaxLength'));
        }

        if (this.$element.attr('minlength')) {
            this.$element
                .off('input.validator', '', $.proxy(this, 'validateFieldMinLength'))
                .on('input.validator', $.proxy(this, 'validateFieldMinLength'));
        }

        if (this.$element.attr('type') === 'tel') {
            this.$element
                .off('input.validator', '', $.proxy(this, 'parsePhone'))
                .on('input.validator', $.proxy(this, 'parsePhone'));
        }

        this.$form
            .off('submit.validator', '', $.proxy(this, 'validateForm'))
            .on('submit.validator', $.proxy(this, 'validateForm'));
    }
}
